import { render, staticRenderFns } from "./AutorizacionCompra.vue?vue&type=template&id=3473072e"
import script from "./AutorizacionCompra.vue?vue&type=script&lang=js"
export * from "./AutorizacionCompra.vue?vue&type=script&lang=js"
import style0 from "./AutorizacionCompra.vue?vue&type=style&index=0&id=3473072e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports